import React, { useEffect, useState } from "react";
import BedroomImage from "../../assets/../assets/home/prperty/prop1.png";
import BathroomImage from "../../assets/../assets/home/prperty/prop2.png";
import SqftImage from "../../assets/../assets/home/prperty/prop3.png";
import YearImage from "../../assets/../assets/home/prperty/prop4.png";
import ParkingImage from "../../assets/../assets/home/prperty/prop5.png";
import UtilitiesImage from "../../assets/../assets/home/prperty/prop6.png";
import HvacImage from "../../assets/../assets/home/prperty/prop7.png";
import WheelchairImage from "../../assets/../assets/home/prperty/prop8.png";
import location from "../../assets/../assets/home/prperty/location.png";
import map from "../../assets/../assets/home/prperty/map.png";
import { Avatar } from "@mui/material";
import { Footer } from "../../Component/Footer";
import { Navbar } from "../../Component/Navbar";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const PropertyDetail = ({ user, initialProperty }) => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [property, setProperty] = useState(location.state || initialProperty);
  const [similarProperties, setSimilarProperties] = useState([]);
  const [allProperties, setAllProperties] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [mainImage, setMainImage] = useState(
    initialProperty?.uploadFiles?.[0] || null
  );
  const [showPopup, setShowPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [purchaseStatus, setPurchaseStatus] = useState(null);

  useEffect(() => {
    if (!id) return;

    const fetchProperty = async () => {
      try {
        const response = await fetch(
          "https://silver-tlc-backend-delta.vercel.app/api/v1/alluser/postservice-form/get-alluser"
        );
        const data = await response.json();
        const foundProperty = data.postServiceFormData.find(
          (item) => item._id === id
        );
        if (foundProperty) {
          setProperty(foundProperty);
          setMainImage(foundProperty.uploadFiles?.[0] || null);
        } else {
          console.error("Property not found");
        }
      } catch (error) {
        console.error("Error fetching property details:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchProperty();
  }, [id]);

  // Buy button feature
  const handleBuy = async () => {
    const authToken = localStorage.getItem("authToken"); // Check if the user is logged in

    if (!authToken) {
      setShowPopup(true);
    } else {
      setLoading(true); // Start loading
      try {
        const response = await fetch(
          "https://silver-tlc-backend-delta.vercel.app/api/v1/userpurchase/property/add",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              token: authToken, // Use the token from localStorage
              propertyFormId: property._id, // Use the property ID from the state
            }),
          }
        );

        const result = await response.json();
        if (response.ok) {
          setPurchaseStatus("success"); // Purchase successful
          console.log("Purchase successful:", result);
        } else {
          setPurchaseStatus("error"); // Purchase failed
          console.error(
            "Purchase failed Login As Individual User",
            result.message
          );
        }
      } catch (error) {
        setPurchaseStatus("error"); // Purchase failed
        console.error("Error during purchase:", error);
      } finally {
        setLoading(false); // Stop loading
      }
    }
  };

  const handlePopupOk = () => {
    // Save the current path and property data in localStorage
    localStorage.setItem("redirectAfterLogin", location.pathname);
    localStorage.setItem("propertyData", JSON.stringify(property)); // Save property data
    setShowPopup(false); // Close the popup
    navigate("/login"); // Navigate to the login page
  };

  const handlePopupCancel = () => {
    setShowPopup(false); // Close the popup
  };

  useEffect(() => {
    // Check for redirection after login
    const redirectPath = localStorage.getItem("redirectAfterLogin");
    const savedPropertyData = localStorage.getItem("propertyData");

    if (user?.isLoggedIn && redirectPath && savedPropertyData) {
      localStorage.removeItem("redirectAfterLogin"); // Clear saved path
      localStorage.removeItem("propertyData"); // Clear saved property data
      setProperty(JSON.parse(savedPropertyData)); // Set the property data
      navigate(redirectPath); // Redirect back to the saved page
    }
  }, [user, navigate]);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="spinner-border text-primary" role="status">
          <span>Loading...</span>
        </div>
      </div>
    );
  }

  if (!property) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="text-gray-500">Property not found.</div>
      </div>
    );
  }

  return (
    <div>
      <Navbar />
      <div className="container mx-auto p-6 font-sans">
        {/* Overview Section */}
        <section className="mb-10 p-4">
          <div className="flex flex-col md:flex-row gap-6 mb-5">
            {/* Main Image */}
            <motion.div
              className="w-full md:w-2/3"
              key={mainImage}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              <img
                src={mainImage || "/placeholder.svg"}
                alt="Main Property"
                className="w-full h-[55vh] object-cover rounded-lg"
              />
            </motion.div>

            {/* Thumbnail Images */}
            <div className="w-full md:w-1/3 flex flex-row md:flex-col gap-4">
              {property.uploadFiles?.map((image, idx) => (
                <motion.div
                  key={idx}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => setMainImage(image)}
                  className="cursor-pointer"
                >
                  <img
                    src={image || "/placeholder.svg"}
                    alt={`Property ${idx + 1}`}
                    className={`w-full h-[15vh] object-cover rounded-lg ${
                      mainImage === image ? "border-4 border-purple-600" : ""
                    }`}
                  />
                </motion.div>
              ))}
            </div>
          </div>

          {/* Overview Text and Map */}
          <div className="space-y-6">
            <h2 className="text-3xl font-bold text-gray-800">
              Property Information
            </h2>
            <p className="text-lg">{property.propertyDetails.title}</p>
            <div className="flex flex-col md:flex-row gap-6">
              <div className="w-full md:w-1/2">
                <div className="bg-white shadow rounded-lg p-6">
                  <h3 className="font-bold text-xl mb-4">Overview</h3>
                  <p className="mb-6">{property.propertyDetails.description}</p>
                  <h4 className="font-bold text-lg mb-2">More Information</h4>
                  <ul className="text-gray-700 space-y-2">
                    <li>📍 {property.propertyDetails.address}</li>
                    <li>💰 ${property.propertyDetails.price}/month</li>
                    <li>🗓️ Available for {property.propertyDetails.status}</li>
                    <li>📞 Contact: (555) 123-4567</li>
                  </ul>
                  <div className="mt-6">
                    <button
                      onClick={handleBuy}
                      className="px-6 py-3 bg-purple-600 text-white rounded-full w-full hover:bg-purple-700 transition-all flex items-center justify-center"
                      disabled={loading} // Disable the button while loading
                    >
                      {loading ? (
                        <div className="flex items-center">
                          <svg
                            className="animate-spin h-5 w-5 mr-3 text-white"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                          >
                            <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                            ></circle>
                            <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            ></path>
                          </svg>
                          Processing...
                        </div>
                      ) : (
                        "Buy Now"
                      )}
                    </button>
                  </div>
                </div>
              </div>

              {/* Login Required Popup */}
              {showPopup && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                  <div className="bg-white p-6 rounded shadow-lg w-96">
                    <h2 className="text-xl font-bold mb-4">Login Required</h2>
                    <p className="mb-6">
                      You need to log in before making a purchase.
                    </p>
                    <div className="flex justify-end space-x-4">
                      <button
                        onClick={handlePopupCancel}
                        className="px-4 py-2 bg-gray-300 text-black rounded hover:bg-gray-400"
                      >
                        Cancel
                      </button>
                      <button
                        onClick={handlePopupOk}
                        className="px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700"
                      >
                        OK
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* Purchase Status Messages */}
              {purchaseStatus === "success" && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                  <div className="bg-white p-6 rounded shadow-lg w-96">
                    <h2 className="text-xl font-bold mb-4">
                      Purchase Successful
                    </h2>
                    <p className="mb-6">
                      Your purchase has been completed successfully.
                    </p>
                    <div className="flex justify-end">
                      <button
                        onClick={() => setPurchaseStatus(null)}
                        className="px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700"
                      >
                        <Link to="/Dashboard/services">OK</Link>
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {purchaseStatus === "error" && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                  <div className="bg-white p-6 rounded shadow-lg w-96">
                    <h2 className="text-xl font-bold mb-4">Purchase Failed</h2>
                    <p className="mb-6">
                      Please login as an individual account and try again
                    </p>
                    <div className="flex justify-end">
                      <button
                        onClick={() => setPurchaseStatus(null)}
                        className="px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700"
                      >
                        OK
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* Map Section */}
              <div className="w-full md:w-1/2">
                <div className="bg-white shadow rounded-lg p-6">
                  <img
                    src={map || "/placeholder.svg"}
                    alt="Property Map"
                    className="w-full h-48 object-cover rounded-lg mb-4"
                  />
                  <h3 className="text-2xl font-bold text-gray-800 mb-4">
                    Explore the Area
                  </h3>
                  <div className="space-y-2">
                    <div className="flex justify-between">
                      <p className="text-gray-600">📍 Hotel Pentivalia</p>
                      <p className="text-gray-600">2 min drive</p>
                    </div>
                    <div className="flex justify-between">
                      <p className="text-gray-600">📍 Travis Bakery House</p>
                      <p className="text-gray-600">4 min drive</p>
                    </div>
                    <div className="flex justify-between">
                      <p className="text-gray-600">📍 Johnson Garden Opal</p>
                      <p className="text-gray-600">6 min drive</p>
                    </div>
                    <div className="flex justify-between">
                      <p className="text-gray-600">📍 Norman Opera Circus</p>
                      <p className="text-gray-600">8 min drive</p>
                    </div>
                    <div className="flex justify-between">
                      <p className="text-gray-600">📍 Rock Desert Hotel</p>
                      <p className="text-gray-600">10 min drive</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Key Property Information */}
        <h3 className="text-2xl font-semibold mb-6 text-center">
          Key Property Information
        </h3>
        <section className="mb-10 bg-white rounded-lg shadow p-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {/* Number of Bedrooms */}
            <div className="rounded-lg p-4 flex items-center text-center flex-col sm:flex-row">
              <img
                src={BedroomImage}
                alt="Number of Bedrooms"
                className="w-16 h-16 sm:w-20 sm:h-20 object-cover rounded-lg mb-2 sm:mb-0 sm:mr-4"
              />
              <div className="flex flex-col items-center sm:items-start">
                <h4 className="font-medium text-gray-700 text-base sm:text-lg">
                  Number of Bedrooms
                </h4>
                <p className="text-gray-600 text-sm sm:text-base mt-1">
                  {property.location.bedrooms} Bedrooms
                </p>
              </div>
            </div>
            {/* Number of Bathrooms */}
            <div className="rounded-lg p-4 flex items-center text-center flex-col sm:flex-row">
              <img
                src={BathroomImage}
                alt="Number of Bathrooms"
                className="w-16 h-16 sm:w-20 sm:h-20 object-cover rounded-lg mb-2 sm:mb-0 sm:mr-4"
              />
              <div className="flex flex-col items-center sm:items-start">
                <h4 className="font-medium text-gray-700 text-base sm:text-lg">
                  Number of Bathrooms
                </h4>
                <p className="text-gray-600 text-sm sm:text-base mt-1">
                  {property.location.baths} Bathrooms
                </p>
              </div>
            </div>
            {/* Square Footage */}
            <div className="rounded-lg p-4 flex items-center text-center flex-col sm:flex-row">
              <img
                src={SqftImage}
                alt="Square Footage"
                className="w-16 h-16 sm:w-20 sm:h-20 object-cover rounded-lg mb-2 sm:mb-0 sm:mr-4"
              />
              <div className="flex flex-col items-center sm:items-start">
                <h4 className="font-medium text-gray-700 text-base sm:text-lg">
                  Square Footage
                </h4>
                <p className="text-gray-600 text-sm sm:text-base mt-1">
                  {property.propertyDetails.squareFootage} sq ft
                </p>
              </div>
            </div>
            {/* Year Built/Renovated */}
            <div className="rounded-lg p-4 flex items-center text-center flex-col sm:flex-row">
              <img
                src={YearImage}
                alt="Year Built/Renovated"
                className="w-16 h-16 sm:w-20 sm:h-20 object-cover rounded-lg mb-2 sm:mb-0 sm:mr-4"
              />
              <div className="flex flex-col items-center sm:items-start">
                <h4 className="font-medium text-gray-700 text-base sm:text-lg">
                  Year Built/Renovated
                </h4>
                <p className="text-gray-600 text-sm sm:text-base mt-1">
                  {property.propertyDetails.yearBuiltOrRemodeled}
                </p>
              </div>
            </div>
            {/* Parking */}
            <div className="rounded-lg p-4 flex items-center text-center flex-col sm:flex-row">
              <img
                src={ParkingImage}
                alt="Parking"
                className="w-16 h-16 sm:w-20 sm:h-20 object-cover rounded-lg mb-2 sm:mb-0 sm:mr-4"
              />
              <div className="flex flex-col items-center sm:items-start">
                <h4 className="font-medium text-gray-700 text-base sm:text-lg">
                  Parking
                </h4>
                <p className="text-gray-600 text-sm sm:text-base mt-1">
                  {property.propertyDetails.parking}
                </p>
              </div>
            </div>
            {/* Utilities */}
            <div className="rounded-lg p-4 flex items-center text-center flex-col sm:flex-row">
              <img
                src={UtilitiesImage}
                alt="Utilities"
                className="w-16 h-16 sm:w-20 sm:h-20 object-cover rounded-lg mb-2 sm:mb-0 sm:mr-4"
              />
              <div className="flex flex-col items-center sm:items-start">
                <h4 className="font-medium text-gray-700 text-base sm:text-lg">
                  Utilities
                </h4>
                <p className="text-gray-600 text-sm sm:text-base mt-1">
                  {property.propertyDetails.utilities}
                </p>
              </div>
            </div>
            {/* Heating and Cooling */}
            <div className="rounded-lg p-4 flex items-center text-center flex-col sm:flex-row">
              <img
                src={HvacImage}
                alt="Heating and Cooling"
                className="w-16 h-16 sm:w-20 sm:h-20 object-cover rounded-lg mb-2 sm:mb-0 sm:mr-4"
              />
              <div className="flex flex-col items-center sm:items-start">
                <h4 className="font-medium text-gray-700 text-base sm:text-lg">
                  Heating and Cooling
                </h4>
                <p className="text-gray-600 text-sm sm:text-base mt-1">
                  {property.propertyDetails.heatingAndCooling}
                </p>
              </div>
            </div>
            {/* Wheelchair Ramp */}
            <div className="rounded-lg p-4 flex items-center text-center flex-col sm:flex-row">
              <img
                src={WheelchairImage}
                alt="Wheelchair Ramp"
                className="w-16 h-16 sm:w-20 sm:h-20 object-cover rounded-lg mb-2 sm:mb-0 sm:mr-4"
              />
              <div className="flex flex-col items-center sm:items-start">
                <h4 className="font-medium text-gray-700 text-base sm:text-lg">
                  Wheelchair Ramp
                </h4>
                <p className="text-gray-600 text-sm sm:text-base mt-1">
                  {property.propertyDetails.wheelchairRamp}
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Additional Features */}
        <h3 className="text-2xl font-semibold mb-6 text-center">
          Additional Features
        </h3>
        <section>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 bg-white shadow-lg rounded-lg p-6">
            {/* Office, Game Room */}
            <div className="flex flex-col items-center text-center mx-auto">
              <div className="bg-slate-400 rounded-full w-16 h-16 flex items-center justify-center mb-4">
                <span className="text-2xl">🛋️</span>
              </div>
              <h4 className="font-medium text-gray-700">Office, Game Room</h4>
            </div>
            {/* Refrigerator, Washer/Dryer */}
            <div className="flex flex-col items-center text-center mx-auto">
              <div className="bg-slate-400 rounded-full w-16 h-16 flex items-center justify-center mb-4">
                <span className="text-2xl">🔌</span>
              </div>
              <h4 className="font-medium text-gray-700">
                Refrigerator, Washer/Dryer
              </h4>
            </div>
            {/* Balcony, Backyard */}
            <div className="flex flex-col items-center text-center mx-auto">
              <div className="bg-slate-400 rounded-full w-16 h-16 flex items-center justify-center mb-4">
                <span className="text-2xl">🌳</span>
              </div>
              <h4 className="font-medium text-gray-700">Balcony, Backyard</h4>
            </div>
            {/* Pool, Gym */}
            <div className="flex flex-col items-center text-center mx-auto">
              <div className="bg-slate-400 rounded-full w-16 h-16 flex items-center justify-center mb-4">
                <span className="text-2xl">⛲</span>
              </div>
              <h4 className="font-medium text-gray-700">Pool, Gym</h4>
            </div>
            {/* Pets Allowed */}
            <div className="flex flex-col items-center text-center mx-auto">
              <div className="bg-slate-400 rounded-full w-16 h-16 flex items-center justify-center mb-4">
                <span className="text-2xl">🐕</span>
              </div>
              <h4 className="font-medium text-gray-700">Pets Allowed</h4>
              <p className="text-gray-600">Yes</p>
            </div>
            {/* Smoking Allowed */}
            <div className="flex flex-col items-center text-center mx-auto">
              <div className="bg-slate-400 rounded-full w-16 h-16 flex items-center justify-center mb-4">
                <span className="text-2xl">🚭</span>
              </div>
              <h4 className="font-medium text-gray-700">Smoking Allowed</h4>
              <p className="text-gray-600">No</p>
            </div>
          </div>
        </section>

        <section className="bg-gray-50 py-10">
          {/* Similar Properties Heading */}
          <div className="container mx-auto text-center mb-8">
            <h2 className="text-2xl font-bold text-gray-800">
              Similar Properties
            </h2>
          </div>

          {/* Property Cards */}
          <div className="container mx-auto overflow-hidden">
            <motion.div
              className="flex"
              animate={{ x: `-${currentIndex * 34.33}%` }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
            >
              {similarProperties.map((similarProperty) => (
                <motion.div
                  key={similarProperty._id}
                  className="bg-white shadow-lg rounded-lg overflow-hidden flex-shrink-0 w-1/3 mx-2"
                >
                  <img
                    src={similarProperty.uploadFiles?.[0] || "/placeholder.svg"}
                    alt={similarProperty.propertyDetails.title}
                    className="w-full h-48 object-cover"
                  />
                  <div className="p-4">
                    <h3 className="text-lg font-semibold text-gray-700">
                      {similarProperty.location.unitTitle}
                    </h3>
                    <p className="text-purple-600 text-lg font-bold">
                      ${similarProperty.propertyDetails.price}
                    </p>
                    <Link
                      to={`/PropertyDetail/${similarProperties._id}`}
                      state={property}
                    >
                      <button className="mt-4 w-full bg-purple-600 text-white py-2 rounded-md hover:bg-purple-700">
                        View More
                      </button>
                    </Link>
                  </div>
                </motion.div>
              ))}
            </motion.div>
          </div>

          {/* Neighborhood Section */}
          <div className="mt-10 bg-gray-100 py-10">
            <div className="container mx-auto text-center">
              <p className="text-lg text-gray-700 font-medium mb-2">
                Explore the neighborhood of this property
              </p>
              <div className="w-full h-64 bg-gray-300 flex items-center justify-center rounded-lg">
                <p className="text-gray-500 italic">Map section here</p>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default PropertyDetail;
